module.exports = __webpack_public_path__ + "static/media/ht.99aabc81.svg";